import React, { useState } from "react";

/**
 * UserAvatar renders a user image when available; otherwise, it displays
 * the first letter of the user's name within a circular avatar, matching
 * existing rounded styles. Sizing and extra classNames can be passed in.
 */
export default function UserAvatar({
  src,
  name,
  size = 90,
  className = "",
  style = {},
  imgAlt = "avatar",
}) {
  const [imgError, setImgError] = useState(false);

  const hasValidSrc = src && typeof src === "string" && src.trim().length > 0 && !imgError;

  const computeInitials = (fullName) => {
    if (!fullName || typeof fullName !== "string") return "?";
    const parts = fullName
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    const first = parts[0].charAt(0).toUpperCase();
    const last = parts[parts.length - 1].charAt(0).toUpperCase();
    return `${first}${last}`;
  };

  const initial = computeInitials(name);

  const dimensionStyle = { width: `${size}px`, height: `${size}px` };

  if (hasValidSrc) {
    return (
      <img
        src={src}
        alt={imgAlt}
        className={`rounded-circle img-fluid ${className}`}
        style={{ ...dimensionStyle, objectFit: "cover", ...style }}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center ${className}`}
      style={{
        ...dimensionStyle,
        backgroundColor: "#1f1f1f",
        color: "#ffffff",
        fontWeight: 600,
        fontSize: Math.max(14, Math.floor(size / 2.7)),
        textTransform: "uppercase",
        userSelect: "none",
        ...style,
      }}
      aria-label={name ? `${name} avatar` : "avatar"}
    >
      {initial}
    </div>
  );
}


